import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button} from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { useStoreDispatch, useStoreSelector } from "../../../../../../hooks/StoreHooks";
import { getCurrentUser } from "../../../../../core/common_functions";
import { usePergolaConfigurationBuilderActions } from "../../../../../../store/reducers/pergola_configuration_builder";
import { useConfigurationsServicePergola } from "../../../../../services/pergola_service";
import { Tubolare } from "../../../../../models/pergola_configuration";
import EsteticaChoices from "./esteticaChoice";

type Props = {
  takeScreenshot?: () => Promise<void>;
};

export const EsteticaPage: React.FC<Props> = ({ takeScreenshot }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const cg = useConfigurationsServicePergola();
  const { base, pergolaConfigurationBuilder } = useStoreSelector(store => store);
  const dispatcher = useStoreDispatch();
  const currentUser = getCurrentUser(base);
  const { setStepActive, setStepComplete } = usePergolaConfigurationBuilderActions();
  const [isSubmit, setSubmit] = useState(false);

  useEffect(() => {
    if (!id || isNaN(Number(id)) || !pergolaConfigurationBuilder.configuration) {
      navigate("/configurations");
    } else {
      dispatcher(setStepActive({ stepSlug: "estetica", isActive: true }));
    }
  }, [id, navigate, dispatcher, pergolaConfigurationBuilder.configuration, setStepActive]);
  const sleep = (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));
  const submit = async () => {
    setSubmit(true);
    try {
      const data : {tubolari: Tubolare[]} = {tubolari: pergolaConfigurationBuilder.tubolari};
      if (pergolaConfigurationBuilder.configuration && data) {
        await cg.updateTubolari(
          currentUser,
          pergolaConfigurationBuilder.configuration.configurationId,
          data
        );
      }
      if (takeScreenshot) {
        await takeScreenshot();
        await sleep(100)
      }
      dispatcher(setStepComplete({ stepSlug: "estetica", isComplete: true }));
      dispatcher(setStepActive({ stepSlug: "accessori-vari", isActive: true }));
      navigate(`/pergola-configurations/${id}/accessori-vari`);
    } catch (e: any) {
      alert(`Errore: ${e?.message || e}`);
    } finally {
      setSubmit(false);
    }
  };

  return (
    <div className="row h-full m-0">
      <div className="row h-full m-0">
        <div>
          <div className="p-4">
            <h5 className="text-primary">Tubolari</h5>
            <EsteticaChoices />
            <div className="d-flex flex-row-reverse justify-content-between mt-3">
              <Button
                disabled={isSubmit}
                variant="contained"
                className="ps-3 pe-1"
                onClick={submit}
              >
                <span>Avanti</span>
                <NavigateNextIcon />
              </Button>
                
              <Button
                variant="contained"
                className="ps-1 pe-3"
                color="secondary"
                onClick={() => {
                  dispatcher(setStepActive({ stepSlug: "fioriere", isActive: true }));
                  navigate(`/pergola-configurations/${pergolaConfigurationBuilder.configuration?.configurationId}/fioriere`);
                }}
              >
                <NavigateBeforeIcon />
                <span>Indietro</span>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
